<h2 mat-dialog-title>Test dialog</h2>
<mat-dialog-content class="mat-typography">
  <div>
    <p>
      Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed venenatis placerat sem sit amet mollis. Sed blandit dapibus viverra. Sed et leo dolor. In
      luctus, massa id consectetur porttitor, lacus felis dapibus massa, et cursus mi erat at ligula. Pellentesque habitant morbi tristique senectus et netus et
      malesuada fames ac turpis egestas. Vivamus ornare risus vitae justo malesuada fermentum. Curabitur maximus luctus justo, quis aliquet nisi hendrerit nec.
      Vivamus mattis porttitor erat et varius. Sed suscipit risus luctus leo aliquet dapibus. Etiam dignissim sollicitudin lectus vitae dapibus. Nulla facilisi.
    </p>

    <p>
      Nunc molestie metus sem, eu congue ante lacinia quis. Curabitur vel gravida nulla. In maximus urna elit, in vulputate enim suscipit vel. Donec vulputate,
      nibh nec lacinia tristique, dui eros eleifend lorem, vel mollis odio nisl sit amet orci. Vestibulum mauris elit, iaculis nec varius quis, convallis eu
      urna. In vel dolor ullamcorper, fringilla diam quis, rhoncus urna. Pellentesque iaculis nunc sit amet malesuada porttitor. Donec bibendum placerat
      suscipit. Proin ullamcorper dui in accumsan eleifend. Sed semper euismod felis. Vestibulum elementum suscipit leo. Nam sodales congue nibh at semper.
      Pellentesque dolor mi, consectetur non ligula ut, molestie efficitur massa.
    </p>

    <p>
      Quisque consequat justo sit amet purus commodo consectetur. Integer rutrum, velit et efficitur consequat, augue ante tristique lorem, vitae venenatis ex
      justo quis risus. Sed sed metus posuere, dictum orci ornare, molestie dui. Vivamus porta nisl ac mi gravida euismod. Sed metus dolor, congue sit amet est
      a, elementum rhoncus massa. Sed porta, nisi et fringilla tempor, enim arcu fringilla ligula, at elementum sapien arcu non ligula. Aenean dolor orci,
      convallis at urna vel, bibendum feugiat risus. Duis rhoncus urna mi, et aliquet sem tempor vel. Phasellus non consectetur mauris.
    </p>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button
    mat-dialog-close
    mat-raised-button>
    Cancel
  </button>
  <button
    color="accent"
    mat-dialog-close
    mat-raised-button>
    Confirm
  </button>
</mat-dialog-actions>
